import difference from "lodash/difference";
import find from "lodash/find";
import join from "lodash/join";
import { TemplateLocale } from "../../types/customization/common";
import { LocalizedContent } from "../../types/customization/text";

class LocalizedContentNotFoundError extends Error {}

const FALLBACK_LOCALES: TemplateLocale[] = ["en", "fr"];

export function buildLocaleChain(locale: TemplateLocale): TemplateLocale[] {
  const fallbackLocales = difference(FALLBACK_LOCALES, [locale]);

  return [locale, ...fallbackLocales];
}

export function findLocalizedContent(
  localizedContents: LocalizedContent[],
  locale: TemplateLocale,
  fallback = true
): LocalizedContent {
  let locales = [locale];

  if (fallback) {
    locales = buildLocaleChain(locale);
  }

  return findLocalizedContentForLocales(localizedContents, locales);
}

export function findLocalizedContentForLocales(
  localizedContents: LocalizedContent[],
  locales: TemplateLocale[]
): LocalizedContent {
  for (const locale of locales) {
    const localizedContent = find(localizedContents, (content) => content.locale === locale);
    if (localizedContent) {
      return localizedContent;
    }
  }

  throw new LocalizedContentNotFoundError(
    `LocalizedContent not found for locale chain ${join(locales, ",")}`
  );
}
